/**
 * Clipboard masthead, set like the rest of the editorial pages: a display
 * title, a serif dek, and a single quiet line of provenance beneath. The dek
 * runs the full column so the header stays short and the shelf starts high.
 */
export const ClipboardPageHeader = () => (
  <header className="shrink-0 px-8 pt-8 pb-4">
    <h1 className="font-display text-4xl leading-none tracking-tight text-zinc-900">
      Clipboard
    </h1>
    <p className="mt-3 max-w-5xl text-base leading-7 text-zinc-600">
      Your own shelf in Paperclip. Anything you add here — PDFs, Word and
      PowerPoint files, bibliographies, links to papers in the corpus — is
      parsed into the same virtual filesystem the agent reads, so it can be
      searched, grepped, and cited alongside the literature.
    </p>
    <p className="mt-2 text-sm leading-6 text-zinc-500">
      Stored privately; only you and the people you share with can read it.{" "}
      <a
        href="/docs#clipboard-overview"
        target="_blank"
        rel="noreferrer"
        className="text-zinc-400 transition-colors hover:text-zinc-900"
      >
        Use it from the CLI ↗
      </a>
    </p>
  </header>
);
